import { FormFieldTypes } from "../../../../../../../data/formFieldType";


const initialState = {
  lClientKey: null,
  lDepartmentKey: null,
}

export const addPendingAffiliatesConfig = {
  name: "Add Pending Affiliate",
  initialState: initialState,
  section: [
    {
      sectionId: "PendingAffiliateSection",
      title: "Pending Affiliate Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, 
      fields: [
        {
          id: "lClientKey",
          label: "Client : ",
          Field_Name: "Client",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lClientKey",
          fieldSetting: {
            isEnableOnChange: true,
            placeholder: "Client",
            allowSpace: true,
            option: []
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
        {
          id: "lDepartmentKey",
          label: "Department : ",
          Field_Name: "Department",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lDepartmentKey",
          fieldSetting: {
            isEnableOnChange: true,
            placeholder: "Department",
            allowSpace: true,
            option: []
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
      ],
    },
  ],
};
